<template>
  <div
    v-for="(prestation, index) in groupedPrestations"
    :key="`${prestation.prestId}-${index}`"
  >
    <div class="prestation-info d-flex flex-column mb-0">
      <p class="m-0 mb-1">
        <PrestationIcon class="prestation-logo me-1" />
        {{ prestation.name }}
        <span v-if="prestation.count > 1">x{{ prestation.count }}</span>
      </p>
      <p class="m-0 mb-1">
        <strong>{{ t('reservations.prestId') }}</strong>
        {{ prestation.prestId }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  /* ------------------- Vue Core & Utilities ------------------- */
  import { computed, defineProps } from 'vue'
  import { useI18n } from 'vue-i18n'

  /* ------------------- Configurations & Enums ------------------- */
  import { PrestType } from '@/config'

  /* ------------------- Components ------------------- */
  import PrestationIcon from '@/assets/PrestationIcon.vue'

  /* ------------------- Types & Interfaces ------------------- */
  import { OptionSummary } from '@/services/BookingService.interface'

  /* ------------------- Props & Interfaces ------------------- */
  interface GroupedPrestation {
    name: string
    prestId: number
    count: number
  }

  const props = defineProps<{
    options: OptionSummary[]
  }>()

  const { t } = useI18n()

  /* ------------------- Computed Properties ------------------- */
  /**
   * Filters options to include only Accomodation prestations and groups them.
   */
  const groupedPrestations = computed<GroupedPrestation[]>(() => {
    const prestationMap = new Map<string, GroupedPrestation>()

    props.options
      .filter(option => option.prestTypeId === PrestType.Accomodation) // Convert options to prestations
      .forEach(option => {
        const key = `${option.prestId}-${option.name}`
        if (prestationMap.has(key)) {
          prestationMap.get(key)!.count += 1
        } else {
          prestationMap.set(key, {
            name: option.name,
            prestId: option.prestId,
            count: 1,
          })
        }
      })

    return Array.from(prestationMap.values())
  })
</script>

<style scoped>
  .prestation-logo {
    width: 21px;
    height: 20px;
  }
</style>
